const module = { name: 'movie/shared/bannerMPS', exports: {} }; const exports = module.exports;



import { mps as mps_AdTypes_onLoad } from 'require-global';

const { AdTypes, onLoad } = mps_AdTypes_onLoad;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_debugLog as debugLog } from 'require-core';



const Selectors = Object.freeze({
    AD: '.ad',
    BANNER_MID_AD: '.js-adunit-bannermid2',
    BANNER_TOP_AD: '.js-adunit-banner',
    MOBILE_STICKY_AD_WRAP: '#mobile-sticky-ad',
    MOBILE_STICKY_AD: '.js-adunit-lockedbannerbottom',
    MOBILE_STICKY_AD_CLOSE: '#mobile-sticky-ad-close',
    VIEWING_TYPE_TOGGLE: '.viewing-type-toggle',
})


const Styles = Object.freeze({
    HIDE: 'hide',
    HIDE_STICKY_AD: 'ad__sticky--mobile-hidden'
})


const HTML = Object.freeze({
    MPS_AD: '<div class="ad-placement js-adunit-banner hide"><div class="ad"></div></div>',
})


const insertedAds = []
function topBannerExists(hasShowtimes, cb) {
    if (typeof cb !== 'function') {
        return debugLog.error(module.name, 'topBannerExists expects cb function');
    }
    onLoad(({ isAvailable }) => {
        if (!isAvailable) {
            return cb(true);
        }
        const topBanner = document.querySelectorAll(Selectors.BANNER_TOP_AD);
        const existingTopBanner = topBanner.length === (hasShowtimes ? 2 : 1);
        cb(existingTopBanner && !topBanner[0].classList.contains(Styles.HIDE));
    });
}
function insertBannerTopAd(opts) {
    topBannerExists(opts.hasShowtimes, (hasBanner) => {
        if (hasBanner) {
            return;
        }
        $(opts.selector || Selectors.VIEWING_TYPE_TOGGLE).after(HTML.MPS_AD);
    });
}
function displayBannerTopAd() {
    onLoad(({ isAvailable, insertAd, refreshAds }) => {
        if (!isAvailable) {
            return;
        }
        const $bannerTopAd = $(Selectors.BANNER_TOP_AD);
        if (!$bannerTopAd.length) {
            debugLog.warn(module.name, 'displayBannerTopAd', 'Banner top ad unit not detected on page');
            $bannerTopAd.addClass(Styles.HIDE);
            return;
        }
        $bannerTopAd.removeClass(Styles.HIDE);
        if (insertedAds[AdTypes.BANNER]) {
            refreshAds(AdTypes.BANNER);
        }
        insertAd(`${Selectors.BANNER_TOP_AD} ${Selectors.AD}`, AdTypes.BANNER);
        insertedAds[AdTypes.BANNER] = true;
    });
}
function displayBannerMidAd() {
    onLoad(({ isAvailable, insertAd, refreshAds }) => {
        if (!isAvailable) {
            return;
        }
        const $bannerMidAd = $(Selectors.BANNER_MID_AD);
        if (!$bannerMidAd.length) {
            debugLog.warn(module.name, 'displayBannerMidAd', 'Banner mid ad unit not detected on page');
            $bannerMidAd.addClass(Styles.HIDE);
            return;
        }
        $bannerMidAd.removeClass(Styles.HIDE);
        if (insertedAds[AdTypes.BANNER_MID]) {
            refreshAds(AdTypes.BANNER_MID);
        }
        insertAd(`${Selectors.BANNER_MID_AD} ${Selectors.AD}`, AdTypes.BANNER_MID);
        insertedAds[AdTypes.BANNER_MID] = true;
    });
}
function removeBannerTopAd() {
    $(Selectors.BANNER_TOP_AD).first().remove();
}


const removeStickyAd = () => $(Selectors.MOBILE_STICKY_AD_WRAP).remove()
function attachStickyAdHandlers(insertAd, _queue) {
    const { LOCKED_BANNER_BOTTOM } = AdTypes;
    _queue.adload.push((e) => {
        if (e._mps._slot === LOCKED_BANNER_BOTTOM && (e.isEmpty || $(Selectors.MOBILE_STICKY_AD).height() !== 50)) {
            debugLog.info(module.name, `removed empty sticky ad (${LOCKED_BANNER_BOTTOM})`);
            removeStickyAd();
        }
    });
    $(Selectors.MOBILE_STICKY_AD_WRAP).removeClass(Styles.HIDE_STICKY_AD);
    insertAd(Selectors.MOBILE_STICKY_AD, LOCKED_BANNER_BOTTOM);
    $(Selectors.MOBILE_STICKY_AD_CLOSE)
        .removeClass(Styles.HIDE)
        .on('click', removeStickyAd);
}
function initStickyAd() {
    onLoad(({ isAvailable, insertAd, _queue }) => {
        if (!isAvailable) {
            return $(Selectors.MOBILE_STICKY_AD_WRAP).remove();
        }
        attachStickyAdHandlers(insertAd, _queue);
    });
}
module.exports = {
    displayBannerMidAd,
    displayBannerTopAd,
    initStickyAd,
    insertBannerTopAd,
    removeBannerTopAd,
    topBannerExists,
};
export default module.exports;